import { Injectable, inject } from '@angular/core';
import { Observable } from "rxjs";
import { AppSettingsService } from "../../core";
import { HttpClient } from "@angular/common/http";
import { UIPermission } from "../models/ui-permission.model";

@Injectable({
  providedIn: "root",
})
/** User Service */
export class UserInfoService {
  private readonly appSettings = inject(AppSettingsService);
  private readonly http = inject(HttpClient);

  private readonly baseUrl = `${this.appSettings.baseApiUrl}/api/userinfo`;

  /** This method is being used to get logged in user PUID */
  public getLoggedInUserPuid(): Observable<string> {
    const url = `${this.baseUrl}/get-user-identifier`;
    return this.http.get<string>(url);
  }

  /** This method is being used to get logged in user claims */
  public getUserClaims(): Observable<object> {
    const url = `${this.baseUrl}/get-user-claims`;
    return this.http.get<object>(url);
  }

  /** This method is being used to get logged in user Name */
  public getLoggedInUserName(): Observable<string> {
    const url = `${this.baseUrl}/get-user-name`;
    return this.http.get<string>(url);
  }

  /** This method is being used to get UI permissions for user */
  public getUIPermissionsForUser(): Observable<UIPermission[]> {
    const url = `${this.baseUrl}/get-ui-permissions-for-user`;
    return this.http.get<UIPermission[]>(url);
  }
}